import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

// adminOnly=true  → only profile==="admin" may access; supervisor+user are
//                   redirected to /tickets (they are authenticated but not
//                   permitted to reach management/settings pages).
const Route = ({ component: Component, isPrivate = false, adminOnly = false, ...rest }) => {
	const { isAuth, loading, user } = useContext(AuthContext);

	if (loading) {
		return <BackdropLoading />;
	}

	if (!isAuth && isPrivate) {
		return <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />;
	}

	if (isAuth && !isPrivate) {
		return <Redirect to={{ pathname: "/", state: { from: rest.location } }} />;
	}

	// Block non-admins from admin-only routes.
	// Supervisor and regular users are redirected to the tickets page.
	if (adminOnly && isAuth && user?.profile !== "admin") {
		return <Redirect to={{ pathname: "/tickets" }} />;
	}

	return <RouterRoute {...rest} component={Component} />;
};

export default Route;
